import { graphql, Link } from 'gatsby'
import React from 'react'
import { Layout, Project } from '../../components'
import { Helmet } from 'react-helmet'
// import * as classes from '../../styles/projects.module.css'
import '../../styles/projects.scss'

const Projects:React.FC = ({ data }:any) => {
    const projects = data.projects.nodes;
    const {contact} = data.contact.siteMetadata
    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Checkout Some of Our Latest Works | Mark It Done</title>
                <link rel="canonical" href="http://mysite.com/example" />
            </Helmet>
            <div className='portfolio'>
                <h2>Portfolio</h2>
                <h3>Projects & websites I've created</h3>
                <div className="projects">
                    {
                        projects && projects.map(project=>
                        <Link to={`${project.frontmatter.slug}`} key={project.id}>
                            <Project 
                                title={project.frontmatter.title}
                                stack={project.frontmatter.stack}
                                thumb={project.frontmatter.thumb}
                            />
                        </Link>    
                        )
                    }
                </div>
                <p>Like what you see? Email me At {contact} for a quote! </p>
            </div>
        </Layout>
        
    )
}
export const query = graphql`
query GetAllProjects {
    projects: allMarkdownRemark(sort: {fields: frontmatter___date, order: ASC}) {
        nodes {
            frontmatter {
              slug
              stack
              title
              thumb{
				childImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            id
        }
    }
    contact: site {
        siteMetadata {
          contact
        }
      }  
}
`

export default Projects
